
export const getInitialTime = () => {
  const defaultDate = new Date();
  const newHour = defaultDate.getTime() - 10800000;

  defaultDate.setTime(newHour);
  defaultDate.setMinutes(0);
  defaultDate.setSeconds(0);

  return defaultDate;
};

export const validateDateAndTime = (selectedDate: Date | null) => {
  const now = new Date();

  selectedDate!.setMilliseconds(0);

  const compareDateObjects = selectedDate! > now;
  return {
    dateValidation: compareDateObjects,
    mixedDateAndTime: selectedDate!,
  };
};

export const mixDates = (date1: any, date2: any) => {
  const date = date2;
  const finalDate = date1;

  const hours = date?.getHours();
  const minutes = date?.getMinutes();
  const seconds = date?.getSeconds();

  finalDate?.setHours(hours);
  finalDate?.setMinutes(minutes);
  finalDate?.setSeconds(seconds);

  return finalDate;
};

export const isTimeObjectValueEqual = (date1: any, date2: any) => {
  return date1?.toLocaleTimeString() === date2?.toLocaleTimeString();
}

export const validateFutureDate = (actualDate: Date | null) => {
  const now = new Date();

  return actualDate! > now;
};

export const getTimeDifferenceBetweenDates = (
  endDate: any,
  startDate: any
) => {
  if (!endDate || !startDate) {
    return {
      validateTimeStamp: false,
      timeStamp: 0,
    }
  }
  return {
    validateTimeStamp: endDate > startDate,
    timeStamp: Math.trunc((endDate.getTime() - startDate.getTime()) / 1000),
  };
};

export const isTimeDifferenceGreaterThanXMinutes = (startDate: Date, endDate: Date, minutes?: number) => {
  minutes = minutes || 10;
  return Math.trunc((endDate?.getTime() - startDate?.getTime()) / 1000) > minutes * 60;
}

export const fromSecondsToLocaleTimeString = (seconds: number) => {
  return new Date(seconds * 1000).toISOString().slice(11, 19);
}

const addZeroIntoSingleNumbers = (number: number) => {
  const numberToString = number.toString();
  return numberToString.length <= 1 ? `0${numberToString}` : numberToString;
};

export const formatCalendar = (scheduleTime: Date) => {
  const day = addZeroIntoSingleNumbers(scheduleTime.getDate());
  const month = addZeroIntoSingleNumbers(scheduleTime.getMonth() + 1);
  const year = scheduleTime.getFullYear();

  return `${day}/${month}/${year}`;
};

export const formattedTimelapse = (videoDate: Date) => {
  const hour = addZeroIntoSingleNumbers(videoDate.getHours());
  const minutes = addZeroIntoSingleNumbers(videoDate.getMinutes());
  const seconds = addZeroIntoSingleNumbers(videoDate.getSeconds());

  return `${hour}:${minutes}:${seconds}`;
};

export function formatTimestampToIsoNumber(timestamp: number) {
  const date = new Date(timestamp);
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() retorna 0-11, então somamos 1
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${year}${month}${day}${hours}${minutes}${seconds}`;
}